import { AgGridReact, Flex, Text } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";

export const BulkArenaAccessCell = ({
  value,
}: AgGridReact.CustomCellRendererProps<"Yes" | "No">) => {
  const hasAccess = value === "Yes";
  const color = hasAccess ? Colors.Success600 : Colors.Neutral600;

  return (
    <Flex flexDirection="row" alignItems="center" gap={4} inline>
      <Text variant={hasAccess ? "strong-md" : "secondary-md"} color={color}>
        {value}
      </Text>
    </Flex>
  );
};
